import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { throttle } from '../../lib/utils';
import { BackButton } from './buttons/BackButton';
import { HintButton } from './buttons/HintButton';

export interface TitleHeaderProps {
  title: string;
  hintPath?: string;
  hintLabel?: string;
  backLabel?: string;
  color: string;
}

export const TitleHeader: React.FC<TitleHeaderProps> = React.memo(
  ({ children, title, hintPath, hintLabel, backLabel, color }) => {
    const history = useHistory();
    const handleHintClick = useCallback(
      throttle(() => {
        if (hintPath) {
          history.push(hintPath);
        }
      }, 1000),
      [hintPath, history]
    );
    return (
      <header
        className={css`
          flex: 0 0 auto;
          width: 100%;
          color: #4d3906;
          position: relative;
          z-index: 10;
          .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 52px;
            padding: 0 4px;
            background: ${color};
          }
          .title {
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .dummy {
            width: 48px;
            height: 48px;
          }
          .arch {
            width: 100%;
            height: 24px;
          }
        `}
      >
        <div className="content">
          {backLabel ? (
            <BackButton ariaLabel={backLabel} />
          ) : (
            <div className="dummy" aria-hidden="true" />
          )}
          <h1 className="title">{title}</h1>
          {hintPath && hintLabel ? (
            <HintButton ariaLabel={hintLabel} onClick={handleHintClick} />
          ) : (
            <div className="dummy" aria-hidden="true" />
          )}
        </div>
        {children}
        <svg
          className="arch"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 370 70"
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            right: 0,
            height: '24px',
            transform: 'translateY(23px)'
          }}
          aria-hidden="true"
        >
          <path
            fill={color}
            d="M370 0H0v47.357C39.163 23.076 107.388 7 185 7s145.837 16.076 185 40.357V0z"
          ></path>
        </svg>
      </header>
    );
  }
);
